import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
function ModuleUpsellComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
} }
function ModuleUpsellComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 6);
    i0.ɵɵtext(5, "Start Trial");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("View ", ctx_r0.title, "");
} }
export class ModuleUpsellComponent {
    constructor() {
        this.show = !window.USER.authenticated;
    }
}
ModuleUpsellComponent.ɵfac = function ModuleUpsellComponent_Factory(t) { return new (t || ModuleUpsellComponent)(); };
ModuleUpsellComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ModuleUpsellComponent, selectors: [["ycn-module-upsell"]], inputs: { title: "title" }, decls: 2, vars: 2, consts: [["class", "locked", 4, "ngIf"], ["class", "panel-locked-message", 4, "ngIf"], [1, "locked"], [1, "panel-locked-message"], [1, "panel-locked-message-wrap"], [1, "mb-row"], ["href", "/start_trial", 1, "btn", "btn-primary", "btn-support"]], template: function ModuleUpsellComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ModuleUpsellComponent_div_0_Template, 1, 0, "div", 0)(1, ModuleUpsellComponent_div_1_Template, 6, 1, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.show);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.show);
    } }, dependencies: [i1.NgIf], encapsulation: 2 });
